export const FILE_INPUT_ACTION = 'FILE_INPUT_ACTION'
export const UPLOAD_ACTION = 'UPLOAD_ACTION'
export const UPLOAD_BUTTON_VALIDATION_ACTION = 'UPLOAD_BUTTON_VALIDATION_ACTION'
export const UPLOAD_BUTTON_ACTION = 'UPLOAD_BUTTON_ACTION'
export const NONE_FILE_DATA_ACTION = 'NONE_FILE_DATA_ACTION'
export const IMG_ACTION = 'IMG_ACTION'
export const INIT = '__INIT__'